export { default } from './BlurredSignUpStep';
